export default __webpack_public_path__ + "static/media/image.d51e3efe.png";